import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import moment from "moment-timezone";

/**
 * Checks if Licence Expire Date is Valid or Not
 * 
 * @returns ValidatorsErrors {licenceExpired: true} || null
 */
export function checkLicenceExpireDate(): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        const licenseDate = moment(value).format('YYYY-MM-DD');
        const todaysDate = moment().format('YYYY-MM-DD');

        const valid = moment(todaysDate).isAfter(licenseDate);

        if (valid === false) {
            return null;
        } else {
            return {
                licenceExpired: true
            };
        }
    }
}

export function emailPatternValidator(): ValidatorFn {
  //custom email validator for email chips field. It validates the input as an array
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || !value.length) {
      return null;
    }

    const emailPatternRegex: RegExp = new RegExp(
      "^[A-Za-z0-9._%+-]+@[a-z0-9.?-]+[.]+[a-z]{2,4}$"
    );
    let isValidEmails: boolean = value.every((email: string) =>
      emailPatternRegex.test(email)
    );
    return !isValidEmails ? { validEmailError: true } : null;
  };
}